import createRootReducer from "./index";
import { routerMiddleware } from "connected-react-router";
import thunkMiddleware from "redux-thunk";
import { history } from "./history";
import { configureStore } from "@reduxjs/toolkit";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
	return configureStore({
		reducer: createRootReducer(history),
		middleware: (getDefaultMiddleware) => [
			...getDefaultMiddleware({
				thunk: true,
				immutableCheck: true,
				serializableCheck: false,
			}),
			thunkMiddleware,
			routerMiddleware(history),
		],
	});
};
